export const getCheckoutStatus = (state) => state.checkoutStatus